import { Children, forwardRef } from "react";
import { useGridRootProps, type GridSlotProps } from "@mui/x-data-grid-premium";

type FilterOperatorInputProps = GridSlotProps["baseSelect"];

// Locks the operator select when a column exposes a single operator (e.g. string
// "contains") and stays interactive otherwise. Registered globally in the theme.
const FilterOperatorInput = forwardRef<
  HTMLDivElement,
  FilterOperatorInputProps
>(function FilterOperatorInput(props, ref) {
  const rootProps = useGridRootProps();
  const BaseSelect = rootProps.slots.baseSelect;
  const lockToSingleOperator = Children.count(props.children) <= 1;

  return (
    <BaseSelect
      ref={ref}
      {...props}
      material={{ ...props.material, disabled: lockToSingleOperator }}
    />
  );
});

export default FilterOperatorInput;
